import React, { Component } from "react";
import "./style.css";
import "../../../../index.css";
import { put } from "../../../../utils/request";
class ModifyPw extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldpassword: "",
      onepassword: "",
      twopassword: "",
      error_visible: false,
      error_info: "",
    };
  }
  render() {
    return (
      <div>
        <div className="mpw_img">
          <img alt="" src={require("../../../../images/user/reset.png")}></img>
        </div>
        <div className="mpw_box">
          <div className="mpw_onepassword">
            <input
              type="password"
              onChange={this.handleOldpasswordChang}
              value={this.state.oldpassword}
              placeholder="请输入旧密码"
            ></input>
          </div>
          <div className="mpw_onepassword">
            <input
              type="password"
              onChange={this.handleOnepasswordChang}
              value={this.state.onepassword}
              placeholder="请输入新密码 （6-18位）"
            ></input>
          </div>
          <div className="mpw_twopassword">
            <input
              type="password"
              onChange={this.handleTwopasswordChang}
              value={this.state.twopassword}
              placeholder="请确认新密码 （6-18位）"
            ></input>
          </div>
          <div onClick={() => this.requestModify()} className="mpw_btn">
            确认修改
          </div>
          <div
            style={
              this.state.error_visible === true
                ? { display: "block" }
                : { display: "none" }
            }
            className="mpw_error"
          >
            <div className="mpw_modal">
              <img
                alt=""
                src={require("../../../../images/user/notice.png")}
              ></img>
              <div className="mpw_error_info">
                <p>{this.state.error_info}</p>
              </div>
              <div
                onClick={() => this.handleCloseModal()}
                className="mpw_error_btn"
              >
                好 的
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  /**
   * 关闭通用的显示框
   */
  handleCloseModal = () => {
    this.setState({
      error_visible: false,
    });
    if (this.state.error_info === "修改密码成功") {
      window.location.href =
        window.location.protocol + "//" + window.location.host;
    }
    if (this.state.error_info === "用户未登录") {
      window.location.href = window.location.href =
        window.location.protocol + "//" + window.location.host;
    }
  };
  handleOldpasswordChang = (e) => {
    this.setState({
      oldpassword: e.target.value,
    });
  };
  handleOnepasswordChang = (e) => {
    this.setState({
      onepassword: e.target.value,
    });
  };
  handleTwopasswordChang = (e) => {
    this.setState({
      twopassword: e.target.value,
    });
  };
  /**
   * 更新密码
   * @returns
   */
  requestModify = () => {
    let params = { oldPwd: "", newPwd: "" };
    params.oldPwd = this.state.oldpassword;
    params.newPwd = this.state.onepassword;

    if (this.state.oldpassword === "") {
      this.setState({
        error_visible: true,
        error_info: "旧密码不能为空",
      });
      return;
    }

    if (this.state.onepassword !== this.state.twopassword) {
      this.setState({
        error_visible: true,
        error_info: "密码不一致",
      });
      return;
    }

    if (
      this.state.onepassword.length < 6 ||
      this.state.onepassword.length > 18
    ) {
      this.setState({
        error_visible: true,
        error_info: "请输入新密码（6-18位）",
      });
      return;
    }

    put("/public/v1/user/modify/pwd", params).then((res) => {
      if (res.status === "success") {
        this.setState({
          error_visible: true,
          error_info: res.data,
          code: "",
        });
      } else {
        this.setState({
          error_visible: true,
          error_info: res.data.err_msg.replace("* ", ""),
          code: "",
        });
      }
    });
  };
}

export default ModifyPw;



// WEBPACK FOOTER //
// ./src/containers/User/components/ModifyPw/index.js